import { useMutation, useQueryClient } from '@tanstack/react-query';
import { shopsService } from '../services/shops.service';

interface DeleteShopParams {
  id: string;
  reason?: string;
  targetShopRefId?: string;
}

export function useDeleteShop() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason, targetShopRefId }: DeleteShopParams) =>
      shopsService.deleteShop(id, reason, targetShopRefId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shops'] });
    },
  });
}
